window.customElements.define('e-tab', class extends HTMLElement {
  constructor() {
    super();

    const triggerTabList = this.querySelectorAll('.tabs__triggers__item');

    const triggerPaginationItem = this.querySelectorAll('.pagination .page-link');

    triggerTabList.forEach((triggerEl) => {
      triggerEl.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        const tabId = triggerEl.getAttribute('data-target').replace('#', '');
        const tabPane = document.getElementById(tabId);

        this.querySelectorAll('.tabs__content__item, .tabs__triggers__item').forEach((el) => {
          el.classList.remove('active');
        });

        triggerEl.classList.add('active');
        tabPane.classList.add('active');
      });
    });
    if (triggerPaginationItem) {
      triggerPaginationItem.forEach((triggerEl) => {
        triggerEl.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          let page = triggerEl.getAttribute('data-page');
          if (!page) {
            // wir haben wahrscheinlich einen Pfeil geklickt
            const currentPage = this.querySelector('.pagination .active .page-link').getAttribute('data-page');
            const direction = triggerEl.getAttribute('data-direction');
            if (direction === 'next') {
              page = parseInt(currentPage, 10) + 1;
            } else {
              page = parseInt(currentPage, 10) - 1;
            }
            // trigger click for page
            this.querySelector(`.page-link[data-page="${page}"]`).click();
            return;
          }

          if (page > 1) {
            // prev link einblenden
            this.querySelector('.pagination .page-link[data-direction="prev"]').disabled = false;
          } else {
            this.querySelector('.pagination .page-link[data-direction="prev"]').disabled = true;
          }
          // wenn die letzt Seite erreicht ist, next link ausblenden
          if (page === this.querySelector('.pagination').getAttribute('data-pages')) {
            this.querySelector('.pagination .page-link[data-direction="next"]').disabled = true;
          } else {
            this.querySelector('.pagination .page-link[data-direction="next"]').disabled = false;
          }

          this.querySelector('.pagination .active').classList.remove('active');
          triggerEl.parentElement.classList.add('active');
          this.querySelectorAll('.tabs__page').forEach((el) => {
            el.classList.add('d-none');
          });
          this.querySelector(`.tabs__page[data-page="${page}"]`).classList.remove('d-none');
          // ersten eintrag auf Seite aktivieren
          this.querySelector(`.tabs__page[data-page="${page}"] .tabs__triggers__item`).click();
        });
      });
    }
  }
});
